<template>
  <div class="rj-page-card">
    <div class="rj-page-card__title">
      国际物流信息
    </div>
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="发运单号：" prop="shippingNum">
          <el-input v-model.trim="searchForm.shippingNum" placeholder="" />
        </el-form-item>
        <el-form-item label="提货单号：" prop="deliveryNum">
          <el-input v-model.trim="searchForm.deliveryNum" placeholder="" />
        </el-form-item>
        <el-form-item label="目的港：" prop="destinationPort">
          <el-input v-model.trim="searchForm.destinationPort" placeholder="" />
        </el-form-item>
        <el-form-item label="提货日期" prop="pickUpDateStart">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.pickUpDateStart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder=""
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.pickUpDateEnd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder=""
                :picker-options="pickerOptions"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="离境日期：" prop="departureDateStart">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.departureDateStart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder=""
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.departureDateEnd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder=""
                :picker-options="pickerOptions"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="抵港日期：" prop="arrivalDateStart">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.arrivalDateStart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder=""
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.arrivalDateEnd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder=""
                :picker-options="pickerOptions"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="tableLoading" @click="doSearch">
            搜索
          </el-button>
          <el-button type="default" @click="resetForm">
            重置
          </el-button>
          <el-button type="default" @click="drawer=true">
            新增物流
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-upload
            action=""
            :show-file-list="false"
            :http-request="uploadaction"
            style="display: inline-block;"
          >
            <el-button type="default">
              导入物流
            </el-button>
          </el-upload>
          <a href="/LogisticsInfotemplate.xlsx" target="_bank">
            <el-button type="text">下载模板</el-button>
          </a>
        </el-form-item>
      </el-form>
      <div v-loading="tableLoading" class="tableBody">
        <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
          <el-table-column prop="shippingNum" label="发运单号" align="left" />
          <el-table-column prop="fhNum" label="发货单号" align="left" />
          <el-table-column prop="deliveryNum" label="提货单号" align="left" />
          <el-table-column prop="pickUpDate" label="提货日期" align="left" />
          <el-table-column prop="departureDate" label="离境日期" align="left" />
          <el-table-column prop="destinationPort" label="目的港" align="left" />
          <el-table-column prop="arrivalDate" label="抵港日期" align="left" />
          <el-table-column prop="deliveryDate" label="派送日期" align="left" />
          <el-table-column label="操作" align="left" width="80">
            <template v-slot="{row}">
              <el-button type="text" @click="showEdi(row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.pageIndex"
            layout="total, prev, pager, next, jumper"
            :total="page.total"
            hide-on-single-page
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
      <el-drawer
        title="新增物流"
        :visible.sync="drawer"
        size="710px"
        :wrapper-closable="false"
      >
        <new-logistics v-if="drawer" @cancel="drawer=false" @success="resetForm" />
      </el-drawer>

      <el-drawer
        title="编辑物流"
        :visible.sync="edidrawer"
        size="710px"
        :wrapper-closable="false"
      >
        <new-logistics v-if="edidrawer" :edi-row="ediRow" @cancel="edidrawer=false" @success="resetForm" />
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { getIntelLogisticsList, importIntelLogistic } from '@/API/international.js';
export default {
  data () {
    return {
      searchForm: {
        shippingNum: '',
        deliveryNum: '',
        destinationPort: '',
        pickUpDateStart: '',
        pickUpDateEnd: '',
        departureDateStart: '',
        arrivalDateStart: '',
        arrivalDateEnd: '',
        createBeginTime: '',
        createEndTime: ''
      },
      page: {
        pageSize: 10,
        total: 0,
        pageIndex: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            const date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      tableLoading: false,
      uploadLoading: false,
      tableData: [],
      drawer: false,
      edidrawer: false,
      ediRow: {}
    };
  },
  components: {
    newLogistics: () => import('./newLogistics')
  },
  methods: {
    doSearch () {
      const params = {
        ...this.searchForm,
        pageSize: this.page.pageSize,
        pageIndex: this.page.pageIndex
      };
      this.tableLoading = true;
      getIntelLogisticsList(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
        this.tableLoading = false;
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    showEdi (row) {
      this.ediRow = row;
      this.edidrawer = true;
    },
    resetForm () {
      this.drawer = false;
      this.edidrawer = false;

      this.$refs.searchForm.resetFields();
      this.doSearch();
    },
    handleSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.pageIndex = 1;
      this.doSearch();
    },
    handleCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    uploadaction (upload) {
      const param = new FormData();
      param.append('file', upload.file);
      this.uploadLoading = true;
      importIntelLogistic(param).then((res) => {
        this.uploadLoading = false;
        const json = res.data;
        if (json.status === '200') {
          this.$message.success('文件导入成功');
          this.resetForm();
        }
      }).catch((res) => {
        this.uploadLoading = false;
      });
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>

<style>

</style>
